import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';
import { JobService } from 'src/app/services/job/job.service';

import { JobAssetModel } from 'src/app/models/job-asset.model';
import { ConditionReportModel } from 'src/app/models/condition-report.model';
import { FileModel } from 'src/app/models/file.model';
import { ObservationModel } from 'src/app/models/observation.model';
import { RemedialModel } from 'src/app/models/remedial.model';
import { RepairModel } from 'src/app/models/repair.model';
import { HistoryModel } from 'src/app/models/history.model';
import { DtRowModel } from 'src/app/models/datatable/dt_row.model';
import { AssetPresetStlModel } from 'src/app/models/asset_preset_stl.model';

import { ModalImageUploadComponent } from '../modal-image-upload/modal-image-upload.component';
import { ModalObservationComponent } from '../modal-observation/modal-observation.component';
import { ModalNewConditionReportComponent } from '../modal-new-condition/modal-new-condition.component';
import { ModalAddLogComponent } from 'src/app/components/modal-add-log/modal-add-log.component';
import { ModalCustomRemedialComponent } from '../modal-custom-remedial/modal-custom-remedial.component';
import { ModalViewImageComponent } from '../modal-view-image/modal-view-image.component';
import { ModalSingleObservationComponent } from '../modal-single-observation/modal-single-observation.component';
import { ModalReportWhereComponent } from '../modal-report-where/modal-report-where.component';

import { Constants } from 'src/app/constants/constants';
import * as FileSaver from 'file-saver';
import { register } from 'swiper/element/bundle';
import Swiper from 'swiper';
import { AssetModel } from 'src/app/models/asset.model';
import { AssetTypeModel } from 'src/app/models/asset-type.model';


@Component({
  selector: 'modal-asset-details',
  templateUrl: './modal-asset-details.component.html',
  styleUrls: ['./modal-asset-details.component.scss'],
})
export class ModalAssetDetailsComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};
  dtRows = new Array<DtRowModel>();

  assetUid: number;
  selectedAssetDetails: AssetModel = null;
  loadingImages: boolean = false;
  imageOneFound: boolean = false;
  imageTwoFound: boolean = false;
  conditionReportUpdate: boolean = false;
  originalConditionReport = null;
  segment: string = 'observation';
  
  editCondition = false;
  assetNameError: boolean = false;
  isEditing: boolean = false;
  uneditedAssetDetails: AssetModel;
  modalOpen: boolean = false;

  changeMade = false;

  swiperEl = null;
  swiperSlideIndex = 0;


  constructor(public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController,
   public assetService: AssetService, public clientService: ClientService,
   private jobService: JobService,  private alertController: AlertController) {

  }


  ngOnInit() 
  {
    this.dtOptions[0] = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order:[[0, 'desc']]
    };

    this.dtOptions[1] = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order:[[0, 'desc']]
    };

    this.dtOptions[2] = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order:[[0, 'asc']]
    };

    this.dtOptions[3] = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order:[[0, 'desc']]
    };
  }


  ionViewWillEnter()
  {
    register();

    this.changeMade = false;
    this.modalOpen = false;
    this.loadingImages = false;
    this.imageOneFound = false;
    this.imageTwoFound = false;

    this.loadAssetDetails();
  }


  ionViewDidEnter()
  {
    this.setUpSwiper();
  }


  ionViewWillLeave()
  {

  }


  closeModal(returnData = null)
  {
    returnData = { reload: this.changeMade }

    this.modalController.dismiss(returnData, null, 'MainAssetDetailsModal');
  }


  setUpSwiper()
  {
    this.swiperSlideIndex = 0;

    this.swiperEl = new Swiper(document.querySelector<HTMLElement>('.swiper'),
    {
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 500,
        modifier: 1,
        slideShadows: false,
      },
      centeredSlides: true,
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    });

    var that = this;

    this.swiperEl.on('slideChange', function () {
      that.swiperSlideChanged(this);
    });
  }


  swiperSlideChanged(data)
  {
    this.swiperSlideIndex = data.realIndex;
  }


  loadAssetDetails()
  {
    this.selectedAssetDetails = null;
    this.assetNameError = false;

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.getAssetDetails(this.assetUid, this.clientService.getClientUid(), this.clientService.getOrganisationUid()).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.selectedAssetDetails = new AssetModel();

          this.selectedAssetDetails.uid                 = Number(this.assetUid);
          this.selectedAssetDetails.name                = response.assetName;
          this.selectedAssetDetails.shortDescription    = response.assetShortDescription;
          this.selectedAssetDetails.longDescription     = response.assetLongDescription;
          this.selectedAssetDetails.locationName        = response.locationName;
          this.selectedAssetDetails.locationLatitude    = response.locationLatitude;
          this.selectedAssetDetails.locationLongitude   = response.locationLongitude;
          this.selectedAssetDetails.lastJobDateTime     = response.lastJobDateTime;
          this.selectedAssetDetails.lastReportDateTime  = response.lastReportDateTime;
          this.selectedAssetDetails.assetLatitude       = response.assetLatitude;
          this.selectedAssetDetails.assetLongitude      = response.assetLongitude;
          this.selectedAssetDetails.powerIssue          = response.powerIssue;
          this.selectedAssetDetails.locationUid         = Number(response.locationUid);
          this.selectedAssetDetails.conditionReport     = new ConditionReportModel();
          this.selectedAssetDetails.observations        = new Array<ObservationModel>();
          this.selectedAssetDetails.photos              = new Array<FileModel>();

          this.selectedAssetDetails.assetType = new AssetTypeModel();
          this.selectedAssetDetails.assetType.allStlPresets = new Array<AssetPresetStlModel>();
          this.selectedAssetDetails.assetType.assetTypeUid  = response.assetTypeUid;
          this.selectedAssetDetails.assetType.isStreetLight = response.isStreetLight;

          
          for (var x = 0; x < response.allAssetPhotos.length; x++)
          {
            var assetPhoto = response.allAssetPhotos[x]
            var photo = new FileModel();

            photo.datetime  = assetPhoto.datetime;
            photo.uid       = assetPhoto.fileUid;
            photo.s3Path    = assetPhoto.s3Path;
            photo.jobId     = assetPhoto.jobId;

            this.selectedAssetDetails.photos.push(photo);
          }
          

          for (var i = 0; i < response.stlPresets.length; i++)
          {
            var presetEntry = response.stlPresets[i];

            var newStlPreset = new AssetPresetStlModel();

            newStlPreset.uid                    = presetEntry.assetStlPresetUid;
            newStlPreset.name                   = presetEntry.assetStlPresetName;
            newStlPreset.defaultStls            = JSON.parse(presetEntry.assetStlPresetRemedials);
            newStlPreset.description            = presetEntry.assetStlPresetDescription;

            this.selectedAssetDetails.assetType.allStlPresets.push(newStlPreset);
          }

          if (response.assetConditionReport)
          {
            var row = response.assetConditionReport;

            this.selectedAssetDetails.conditionReport.conditionReportUid        = Number(row.conditionReportUid);
            this.selectedAssetDetails.conditionReport.conditionReportDateTime   = row.conditionReportDateTime;
            this.selectedAssetDetails.conditionReport.condition                 = row.condition;
            this.selectedAssetDetails.conditionReport.approxAge                 = row.approxAge;
            this.selectedAssetDetails.conditionReport.columnType                = row.columnType;
            this.selectedAssetDetails.conditionReport.columnTypeOther           = row.columnTypeOther;
            this.selectedAssetDetails.conditionReport.headType                  = row.headType;
            this.selectedAssetDetails.conditionReport.headTypeOther             = row.headTypeOther;
            this.selectedAssetDetails.conditionReport.notes                     = row.notes;
            this.selectedAssetDetails.conditionReport.userName                  = row.userName;
            this.selectedAssetDetails.conditionReport.photos                    = new Array<FileModel>();
          }

          for (var i = 0; i < response.assetObservations.length; i++)
          {
            var entry = response.assetObservations[i];

            var observation                   = new ObservationModel();
            observation.uid                   = Number(entry.assetObservationUid);
            observation.observationInfo       = entry.observationInfo;
            observation.conditionCode         = entry.conditionCode;
            observation.ref                   = entry.observationRef;

            var mydate = new Date(entry.observedDateTime).toLocaleDateString();

            observation.observedDateTime                  = mydate;
            observation.chosenRemedials                   = new Array<RemedialModel>();
            observation.customRemedials                   = new Array<RemedialModel>();
            observation.presetStlRemedialUids             = new Array<any>(); // @Fil Can be removed once updated to use model below
            observation.currentStlPresets                 = new Array<AssetPresetStlModel>(); 
            observation.loggedByUser                      = entry.loggedByUser;
            observation.repairedOnJobUid                  = entry.repairedOnJobUid;
            observation.recommendedOnJobUid               = entry.recommendedOnJobUid;
            observation.repairedByUser                    = entry.repairedByUser;
            observation.recommendedByUser                 = entry.recommendedByUser;
            observation.repairNotes                       = entry.repairNotes;
            observation.condemnAssetReuseParts            = entry.condemnAssetReuseParts;
            observation.condemnAssetReusePartsText        = entry.condemnAssetReusePartsText;
            observation.condemnAssetIsolated              = entry.condemnAssetIsolated;
            observation.condemnFuseRemoved                = entry.condemnFuseRemoved;
            observation.condemnAssetSufficientLighting    = entry.condemnAssetSufficientLighting;
            observation.condemnAssetDangerousPosition     = entry.condemnAssetDangerousPosition;
            observation.condemnAssetDangerousPositionText = entry.condemnAssetDangerousPositionText;
            observation.observedDateTimeReadable          = entry.observedDateTimeReadable;
            observation.recommendedDateTimeReadable       = entry.recommendedDateTimeReadable;
            observation.repairedDateTimeReadable          = entry.repairedDateTimeReadable;

            observation.repairedDateTime      = null;
            observation.recommendedDateTime   = null;
            observation.powerIssue            = null;

            if (entry.powerIssue)
            {
              observation.powerIssue = entry.powerIssue;
            }

            if (entry.repairedDateTime) 
            {
              observation.repairedDateTime = entry.repairedDateTime;
            }

            if (entry.recommendedDateTime) 
            {
              observation.recommendedDateTime = entry.recommendedDateTime;
            }

            for (var y = 0; y < entry.remedials.length; y++)
            {
              var newRemedial = new RemedialModel();

              newRemedial.assetObservationRemedialUid   = Number(entry.remedials[y].assetObservationRemedialUid);
              newRemedial.stlCode                       = entry.remedials[y].stlCode;
              newRemedial.quantity                      = Number(entry.remedials[y].stlQuantity);
              newRemedial.name                          = entry.remedials[y].remedialName;
              newRemedial.remedialUid                   = Number(entry.remedials[y].remedialUid);

              observation.chosenRemedials.push(newRemedial)
            }   

            for (var z = 0; z < entry.customRemedials.length; z++)
            {
              var newCustomRemedial = new RemedialModel();

              newCustomRemedial.assetObservationCustomRemedialUid   = Number(entry.customRemedials[z].assetObservationCustomRemedialUid);
              newCustomRemedial.stlCode                             = entry.customRemedials[z].customRemedialCode;
              newCustomRemedial.name                                = entry.customRemedials[z].customRemedialName;
              newCustomRemedial.charge                              = entry.customRemedials[z].customRemedialCharge;

              observation.customRemedials.push(newCustomRemedial)
            }   

            for (var z = 0; z < entry.stlPresets.length; z++)
            {
              // @Fil Can be removed once updated to use model below
              //observation.presetStlRemedialUids.push(entry.stlPresets[z].stlPresetUid);

              var newStlPreset  = new AssetPresetStlModel();
              newStlPreset.uid  = entry.stlPresets[z].stlPresetUid;
              newStlPreset.name = entry.stlPresets[z].stlPresetName;
              
              observation.currentStlPresets.push(newStlPreset);
            }

            this.selectedAssetDetails.observations.push(observation);
          }

          for (var i = 0; i < response.assetRepairs.length; i++)
          {
            var entry = response.assetRepairs[i];

            var repair = new RepairModel();

            repair.uid                = Number(entry.assetObservationUid);
            repair.observationRef     = entry.observationRef;
            repair.notes              = entry.repairInfo;
            repair.jobUid             = Number(entry.jobUid);
            repair.jobId              = entry.jobId;
            repair.observedDateTime   = entry.repairDateTime;
            repair.loggedByUser       = entry.loggedByUser;
            repair.concatRepairNames  = entry.concatRepairNames;

            this.selectedAssetDetails.repairs.push(repair);
          }

          this.selectedAssetDetails.history = Array<HistoryModel>();

          for (var i = 0; i < response.assetHistory.length; i++)
          {
            var log = response.assetHistory[i];

            var newLog      = new HistoryModel();
            newLog.uid      = log.historyUid;
            newLog.dateTime = log.historyDateTime;
            newLog.log      = log.HistoryLog;
            newLog.userName = log.historyUser;
            
            this.selectedAssetDetails.history.push(newLog);
          }

          this.getBase64forImages();
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
          this.closeModal(null);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
        this.closeModal(null);

      });
    });
  }


  async getBase64forImages()
  {
    var that = this;
    this.selectedAssetDetails.photos.forEach(function (item, i, photos) {

      item.loading = true;

      that.assetService.getAssetImage(item.s3Path, that.selectedAssetDetails.jobAssetUid, that.clientService.getClientUid(), that.clientService.getOrganisationUid()).subscribe(response => {

        if (response.Success)
        {
          if (photos[i])
          {
            photos[i].loading = false;
            photos[i].base64 = response.Image;
          }
        }
        else
        {
          that.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {
  
        that.appearanceService.dismissLoading();
        that.appearanceService.presentToast(err, Constants.TOAST_ERROR);
      });     
    });   
  }


  openImage(s3Path)
  {
    var payload = {
      s3Path: s3Path
    };
    
    this.appearanceService.showLoading("Please wait...").then(() => {

      this.jobService.getJobAssetImage(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.viewImage(response.Image);
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
      });
    });
  }


  async viewImage(base64)
  {
    const modal = await this.modalController.create({
      component: ModalViewImageComponent,
      backdropDismiss: true,
      componentProps: { 
        base64Image: base64
      },
      id: 'ImageModal'
    });

    modal.onDidDismiss().then((response) => {

    })

    return await modal.present();
  }


  editAsset()
  {
    this.isEditing = true;

    this.uneditedAssetDetails = JSON.parse(JSON.stringify(this.selectedAssetDetails));
  }


  saveAsset()
  {
    this.isEditing = false;

    if (this.uneditedAssetDetails.name != this.selectedAssetDetails.name ||
       this.uneditedAssetDetails.shortDescription != this.selectedAssetDetails.shortDescription || 
       this.uneditedAssetDetails.longDescription != this.selectedAssetDetails.longDescription)
    {
        if (this.doesAssetHaveErrors())
        {
          return;
        }

      var payload = {
        assetUid: this.selectedAssetDetails.uid,
        assetName: this.selectedAssetDetails.name,
        shortDescription: this.selectedAssetDetails.shortDescription,
        longDescription: this.selectedAssetDetails.longDescription
      }

      this.appearanceService.showLoading("Please wait...").then(() => {

        this.assetService.updateAsset(payload).subscribe(response => {

          this.appearanceService.dismissLoading();

          if (response.Success)
          {
            this.isEditing = false;
            this.changeMade = true;
            this.appearanceService.presentToast("Asset updated.", Constants.TOAST_SUCCESS);
            this.loadAssetDetails();
          }
          else
          {
            this.appearanceService.presentToast(response.Message, Constants.TOAST_INFO);
          }
        },
        err => 
        {
          this.appearanceService.dismissLoading();
          this.appearanceService.presentToast("Failed to update asset.", Constants.TOAST_ERROR);
        });
      });
    }
  }


  doesAssetHaveErrors()
  {
    var errorFound = false;
    this.assetNameError = false;

    if (this.selectedAssetDetails.name == "")
    {
      this.assetNameError = true;
      errorFound = true;
    }

    return errorFound;
  }


  async changeReportedUser(isRepair, obs, isRecommended)
  {
    const modal = await this.modalController.create({
      component: ModalReportWhereComponent,
      backdropDismiss: false,
      componentProps: { selectedList: [], whereCriteria: "users" , limit: 1},
      id: 'ReportWhereModal'
    });

    modal.onDidDismiss().then(async (response) => {

      if (response.data)
      {
        if (response.data.selected)
        {          
          var payload = {
            isRepair: isRepair,
            isRecommended: isRecommended,
            observationUid: obs.uid,
            newUserUid: response.data.selected[0].uid,
            newUserName: response.data.selected[0].name
          }

          this.appearanceService.showLoading("Please wait...").then(() => {

            this.assetService.changeNameOnObservation(payload).subscribe(response => {
          
              this.appearanceService.dismissLoading();
      
              if (response.Success)
              {
                if (isRepair)
                {
                  obs.repairedByUser = payload.newUserName;
                }
                else if (isRecommended)
                {
                  obs.recommendedByUser = payload.newUserName;
                }
                else
                {
                  obs.loggedByUser = payload.newUserName;
                }
              }
              else
              {
                this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
              }
            },
            err => {
      
              this.appearanceService.dismissLoading();
              this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
      
            });
          });
        }
      }
    })

    return await modal.present();
  }


  async uploadPhoto(index) 
  {
    const modal = await this.modalController.create({
      component: ModalImageUploadComponent,
      backdropDismiss: false,
      componentProps: { 
        reportUid: this.selectedAssetDetails.conditionReport.conditionReportUid,
        assetUid: this.selectedAssetDetails.uid,
        uploadUrl: "report/image/upload",
        resource: 'report'
      },
      cssClass: 'ninety8-screen-modal',
      id: 'ImageUploadModal'
    });

    modal.onDidDismiss().then((response) => {

      if (response.data)
      {
        if (response.data.addedFile)
        {
          this.loadAssetDetails();
        }
      }
    })

    return await modal.present();
  }


  downloadPhoto(index, assetName)
  {
    var payload = {
      s3Path: this.selectedAssetDetails.photos[index].s3Path
    };

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.jobService.getJobAssetImage(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          // Split the base64 string in data and contentType
          var block = response.Image.split(";");
          // Get the content type
          var dataType = block[0].split(":")[1];

          // get the real base64 content of the file
          var realData = block[1].split(",")[1];// In this case "JVBERi0xLjcKCjE...."

          var blob = this.b64toBlob(realData, dataType);

          var s3PathSplit = this.selectedAssetDetails.photos[index].s3Path.split('/');

          var fileName =  s3PathSplit[s3PathSplit.length-1];
          FileSaver.saveAs(blob, assetName + "_" + fileName);
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
      });
    });


    
  }


  b64toBlob(b64Data, contentType, sliceSize = null) 
  {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    
    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) 
    {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);

        for (var i = 0; i < slice.length; i++) 
        {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, {type: contentType});

    return blob;
  }


  async deletePhoto(index)
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to delete this photo?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            this.confirmedDeletePhoto(index);

          },
        },
      ],
    });

    await alert.present();
  }


  confirmedDeletePhoto(index)
  {
    var payload = {
      assetFileUid: this.selectedAssetDetails.photos[index].uid,
      assetUid: this.selectedAssetDetails.uid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid()
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.deleteAssetPhoto(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.selectedAssetDetails.photos.splice(index, 1);

          this.appearanceService.presentToast("Image deleted.", Constants.TOAST_SUCCESS);
          this.swiperEl.removeSlide(index);   
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => 
      {
        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast("Failed to delete Image.", Constants.TOAST_ERROR);
      });
    });
  }

  async deleteAsset(assetUid) 
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to delete this asset?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            this.confirmedDeleteAsset(assetUid);

          },
        },
      ],
    });

    await alert.present();
  }


  confirmedDeleteAsset(uid)
  {
    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.deleteAsset(uid, this.clientService.getClientUid(), this.clientService.getOrganisationUid()).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          this.loadAssetDetails();
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async deleteObservation(assetObservationUid) 
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to delete this observation?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            this.confirmedDeleteObservation(assetObservationUid);

          },
        },
      ],
    });

    await alert.present();
  }


  confirmedDeleteObservation(observation)
  {
    var payload = {
      observation: observation,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetName: this.selectedAssetDetails.name
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.deleteObservationFromAsset(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          this.loadAssetDetails();
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async askToDeleteObservationStl(observation, slidingRow, remedial)
  {
    var deleteAll = false;
    
    if(remedial.quantity > 1)
    {
      const alert = await this.alertController.create({
        header: 'Would you like to delete all or just one of ' + remedial.name + '?',
        buttons: [
          {
            text: 'Just One',
            role: 'confirm',
            handler: () => {
              this.confirmDeleteRemedialStl(observation, slidingRow, remedial.remedialUid, deleteAll);
            },
          },
          {
            text: 'All',
            role: 'confirm',
            handler: (data) => {
              deleteAll = true;
              this.confirmDeleteRemedialStl(observation, slidingRow, remedial.remedialUid, deleteAll);
            },
          },
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              slidingRow.close();
            },
          },
        ],
      });
  
      await alert.present();
    }
    else
    {
      const alert = await this.alertController.create({
        header: 'Are you sure you want to delete ' + remedial.name + '?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {
              slidingRow.close();
            },
          },
          {
            text: 'Yes',
            role: 'confirm',
            handler: (data) => {
              deleteAll = true;
              this.confirmDeleteRemedialStl(observation, slidingRow, remedial.remedialUid, deleteAll);
            },
          },
        ],
      });
  
      await alert.present();
    }

  }


  async askToDeleteObservationCustomRemedial(observation, slidingRow, remedial)
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to delete (' + remedial.stlCode + ") - " + remedial.name + '?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            slidingRow.close();
          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            this.confirmDeleteCustomRemedialStl(observation, slidingRow, remedial.assetObservationCustomRemedialUid);

          },
        },
      ],
    });

    await alert.present();
  }


  confirmDeleteCustomRemedialStl(observation, slidingRow, assetObservationCustomRemedialUid)
  {
    var payload = {
      observationUid: observation.uid,
      assetObservationCustomRemedialUid: assetObservationCustomRemedialUid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetUid: this.selectedAssetDetails.uid
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.removeCustomRemedialStlFromObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();
        slidingRow.close();

        if (response.Success)
        {
          this.changeMade = true;

          observation.customRemedials = new Array<RemedialModel>();

          for (var i = 0; i < response.ObservationCustomRemedials.length; i++)
          {
            var newCustomRemedial = new RemedialModel();

            newCustomRemedial.assetObservationCustomRemedialUid   = Number(response.ObservationCustomRemedials[i].assetObservationCustomRemedialUid);
            newCustomRemedial.stlCode                             = response.ObservationCustomRemedials[i].customRemedialCode;
            newCustomRemedial.name                                = response.ObservationCustomRemedials[i].customRemedialName;
            newCustomRemedial.charge                              = response.ObservationCustomRemedials[i].customRemedialCharge;

            observation.customRemedials.push(newCustomRemedial)
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        slidingRow.close();
        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  confirmDeleteRemedialStl(observation, slidingRow, remedialUid, deleteAll)
  {
    var payload = {
      observationUid: observation.uid,
      remedialUid: remedialUid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetUid: this.selectedAssetDetails.uid,
      deleteAll: deleteAll
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.removeRemedialStlFromObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();
        slidingRow.close();

        if (response.Success)
        {
          this.changeMade = true;

          observation.chosenRemedials = new Array<RemedialModel>();

          for (var i = 0; i < response.Observations.length; i++)
          {
            var newRemedial = new RemedialModel();

            newRemedial.assetObservationRemedialUid   = Number(response.Observations[i].assetObservationRemedialUid);
            newRemedial.quantity                      = Number(response.Observations[i].stlQuantity);
            newRemedial.stlCode                       = response.Observations[i].stlCode;
            newRemedial.name                          = response.Observations[i].remedialName;
            newRemedial.remedialUid                   = Number(response.Observations[i].remedialUid);

            observation.chosenRemedials.push(newRemedial)
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        slidingRow.close();
        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async addCustomRemedial(observation)
  {
    this.modalOpen = true;

    const modal = await this.modalController.create({
      component: ModalCustomRemedialComponent,
      backdropDismiss: false,
      componentProps: {  },
      id: 'CustomRemedialModal'
    });

    modal.onDidDismiss().then((response) => {

      this.modalOpen = false;
      
      if (response.data)
      {
        if (response.data.customRemedial)
        {
          this.confirmAddCustomRemedial(observation, response.data.customRemedial);
        }
      }
    })

    return await modal.present();
  }


  confirmAddCustomRemedial(observation, customRemedial)
  {
    var payload = {
      observation: observation,
      newCustomRemedial: customRemedial,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetUid: this.selectedAssetDetails.uid,
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.addCustomRemedialStlToObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;

          observation.customRemedials = new Array<RemedialModel>();

          for (var i = 0; i < response.ObservationCustomRemedials.length; i++)
          {
            var newCustomRemedial = new RemedialModel();

            newCustomRemedial.assetObservationCustomRemedialUid = Number(response.ObservationCustomRemedials[i].assetObservationCustomRemedialUid);
            newCustomRemedial.stlCode                           = response.ObservationCustomRemedials[i].customRemedialCode;
            newCustomRemedial.name                              = response.ObservationCustomRemedials[i].customRemedialName;
            newCustomRemedial.charge                            = response.ObservationCustomRemedials[i].customRemedialCharge;

            observation.customRemedials.push(newCustomRemedial)
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async deletePowerAlert(observation) 
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to remove this power alert?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            var payload = {
              observationUid: observation.uid,
              clientUid: this.clientService.getClientUid(),
              organisationUid: this.clientService.getOrganisationUid()
            }

            this.appearanceService.showLoading("Please wait...").then(() => {

              this.assetService.removePowerIssueFromObservation(payload).subscribe(response => {
            
                this.appearanceService.dismissLoading();
        
                if (response.Success)
                {
                  observation.powerIssue = false;
                }
                else
                {
                  this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
                }
              },
              err => {
        
                this.appearanceService.dismissLoading();
                this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
        
              });
            });
          },
        },
      ]
    });

    await alert.present();
  }


  async editObservationModal(observation)
  {
    const modal = await this.modalController.create({
      component: ModalObservationComponent,
      backdropDismiss: false,
      componentProps: { 
        createNewObservation: false, 
        isEditing: true, 
        originalObservation: observation,
        selectedAsset: this.selectedAssetDetails
      },
      cssClass: 'full-screen-modal',
      id: 'RemedialModal'
    });

    modal.onDidDismiss().then((response) => {
      if (response)
      {
        if (response.data)
        {
          if (response.data.updateObservation)
          {
            var payload = {
              observationUid: observation.uid,
              observationInfo: response.data.updatedInfo,
              updatedConditionCode: response.data.updatedConditionCode,
              newStls: response.data.newStls,
              changedStls: response.data.changedStls,
              clientUid: this.clientService.getClientUid(),
              organisationUid: this.clientService.getOrganisationUid(),
              assetUid: this.selectedAssetDetails.uid,
              newStlPresetUids: response.data.newStlPresetUids,
              deletedStlPresetUids: response.data.deletedStlPresetUids,
              condemnData: null
            };

            this.confirmObservationEdit(payload);
          }
        }
      }
    })

    return await modal.present();
  }


  confirmObservationEdit(payload)
  {
    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.updateObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          this.loadAssetDetails();
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async duplicateLastObservation()
  {
    let lastObs = this.assetService.getLastObservation();

    const modal = await this.modalController.create({
      component: ModalObservationComponent,
      backdropDismiss: false,
      componentProps: { 
        createNewObservation: false, 
        isEditing: false, 
        originalObservation: lastObs, 
        isDuplicating: true,
        selectedAsset: this.selectedAssetDetails
      },
      cssClass: 'full-screen-modal',
      id: 'RemedialModal'
    });

    modal.onDidDismiss().then((response) => {

      if (response)
      {
        if (response.data)
        {
          if (response.data.observation)
          {
            this.createNewObservation(response.data.observation);
          }
        }
      }
    })

    return await modal.present();
  }

  
  async createNewObservationModal()
  {
    const modal = await this.modalController.create({
      component: ModalObservationComponent,
      backdropDismiss: false,
      componentProps: { 
        createNewObservation: true, 
        isEditing: false,
        selectedAsset: this.selectedAssetDetails
      },
      cssClass: 'full-screen-modal',
      id: 'RemedialModal'
    });

    modal.onDidDismiss().then((response) => {

      if (response)
      {
        if (response.data)
        {
          if (response.data.observation)
          {
            this.createNewObservation(response.data.observation);
          }
        }
      }
    })

    return await modal.present();
  }


  async createAssetAlert()
  {
    const alert = await this.alertController.create({
      header: 'Please enter an alert note',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
        
          },
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: (data) => {
            
            if (data.name.length > 0)
            {
              this.addAssetAlert(data.name);
            }
          },
        },
      ],
      inputs: [
        {
          placeholder: 'Alert note',
          name: 'name',
          attributes: {
            maxlength: 255,
          },
        },
      ],
    });

    await alert.present();
  }


  addAssetAlert(note)
  {
    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      note: note,
      jobUid: null,
      assetUid: this.selectedAssetDetails.uid,
      locationUid: null
    };

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.jobService.createJobAlert(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.appearanceService.presentToast("Alert Created", Constants.TOAST_SUCCESS);

          this.appearanceService.triggerEvent('badgeCounters:update', { });
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  createNewObservation(observation)
  {
    var payload = {
      newObservation: observation,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetUid: this.selectedAssetDetails.uid,
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.addObservationToAsset(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          this.loadAssetDetails();
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  wasConditionReportEdited(currentConditionReport): boolean
  {
    var conditionReport = {...currentConditionReport};
    conditionReport.photos = [];

    return JSON.stringify(this.originalConditionReport) != JSON.stringify(conditionReport);
  }

  
  editConditionReport(conditionReport)
  {
    this.editCondition = true;
    this.originalConditionReport = JSON.parse(JSON.stringify(conditionReport));
    this.originalConditionReport.photos = [];
  }


  async updateConditionReport(conditionReport)
  {
    if (!this.wasConditionReportEdited(conditionReport))
    {
      this.appearanceService.presentToast("Nothing changed.", Constants.TOAST_SUCCESS);
      this.editCondition = false;
      return;
    }

    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      conditionReport: conditionReport,
      assetUid: this.selectedAssetDetails.uid,
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.updateAssetConditionReport(payload).subscribe(response => {
    
        this.editCondition = false;

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          this.loadAssetDetails();
          this.appearanceService.presentToast("Saved.", Constants.TOAST_SUCCESS);
        }
        else
        {
            this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
      });
    });
  }


  viewJobPhoto(jobPhoto)
  {
    alert("TODO");
  }


  async addAssetHistoryLog()
  {
    const modal = await this.modalController.create({
      component: ModalAddLogComponent,
      backdropDismiss: true,
      componentProps: { },
      id: 'AddHistoryLogModal'
    });

    modal.onDidDismiss().then((response) => {

      if (response.data)
      {
        if (response.data.logMessage)
        {
          var payload = 
          {
            assetUid: this.selectedAssetDetails.uid,
            logMessage: response.data.logMessage
          }

          this.appearanceService.showLoading("Please wait...").then(() => {

            this.assetService.addAssetHistoryLog(payload).subscribe(response => {
              
                this.appearanceService.dismissLoading();
      
                if (response.Success)
                {
                  this.loadAssetDetails();
                }
                else
                {
                  this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
                }
            
              },
              err => 
              {
                this.appearanceService.dismissLoading();
                this.appearanceService.presentToast("Failed to add log.", Constants.TOAST_ERROR);
              });
            });
        }
      }
    })

    return await modal.present();

  }


  async showNewConditionReportModal() 
  {
    const modal = await this.modalController.create({
      component: ModalNewConditionReportComponent,
      backdropDismiss: false,
      componentProps: { 
        assetUid: this.selectedAssetDetails.uid,
        isStreetLight: this.selectedAssetDetails.assetType.isStreetLight
      },
      cssClass: 'ninety8-screen-modal',
      id: 'NewConditionModal'
    });

    modal.onDidDismiss().then((response) => {

      if (response.data)
      {
        if (response.data.reload)
        {
          this.changeMade = true;
          this.loadAssetDetails();
        }
      }
    })

    return await modal.present();
  }


  markObservationRecommended(obs)
  {
    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      observationUid: obs.uid,
      jobUid: 1
    };

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.addRecommendationToObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          this.loadAssetDetails();
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  markObservationNotRecommended(obs)
  {
    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      observationUid: obs.uid
    };

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.removeRecommendationToObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          obs.recommendedDateTime = null;
          obs.recommendedOnJobUid = null;
          obs.recommndedByUser = null;
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async addPowerIssueToObservation(observation)
  {
    const alert = await this.alertController.create({
      header: 'Who is responsible for this power issue?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Save',
          role: 'confirm',
          handler: (data) => {
            
            if (data == null)
            {
              this.appearanceService.presentToast("Please make a selection", Constants.TOAST_INFO);
              this.addPowerIssueToObservation(observation);
            }
            else
            {
              this.confirmedAddPowerIssueToObservation(data, observation);
            }
          },
        },
      ],
      inputs: [
        {
          label: 'Private',
          type: 'radio',
          value: '1',
        },
        {
          label: 'D.N.O.',
          type: 'radio',
          value: '2',
        },
      ],
    });

    await alert.present();
  }


  confirmedAddPowerIssueToObservation(choice, observation)
  {
    var payload = {
      observationUid: observation.uid,
      powerIssue: choice,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.addPowerIssueToObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          observation.powerIssue = choice;
          this.appearanceService.triggerEvent('badgeCounters:update', { });    
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  getObservationClass(observation: ObservationModel)
  {
    if (observation.condemnAssetReuseParts)
    {
      return 'condemned-card';
    }
    else if (observation.repairedOnJobUid)
    {
      return 'repaired-card';
    }
    else if (observation.recommendedOnJobUid)
    {
      return 'recommended-card';
    }

    return 'obs-card';
  }


  getObservationCardTitle(observation: ObservationModel)
  {
    if (observation.condemnAssetReuseParts)
    {
      return 'Condemned';
    }
    else if (observation.recommendedOnJobUid && !observation.repairedOnJobUid)
    {
      return "Recommended";
    }
    else if (observation.repairedOnJobUid)
    {
      return "Repaired";
    }

    return observation.conditionCode;
  }


  getObservationCardTitleColor(observation: ObservationModel)
  {
    if (observation.condemnAssetReuseParts)
    {
      return 'danger';
    }
    else if (observation.recommendedOnJobUid && !observation.repairedOnJobUid)
    {
      return "warning";
    }
    else if (observation.repairedOnJobUid)
    {
      return "success";
    }

    return ""
  }


  canWeRecommenedObservation(observation: ObservationModel)
  {
    if (observation.recommendedOnJobUid || observation.repairedOnJobUid || observation.condemnAssetReuseParts)
    {
      return false;
    }

    return true;
  }


  canWeUnrecommenedObservation(observation: ObservationModel)
  {
    if (observation.repairedOnJobUid || observation.condemnAssetReuseParts)
    {
      return false;
    }

    if (observation.recommendedOnJobUid)
    {
      return true;
    }

    return false;
  }


  canWeRepairObservation(observation: ObservationModel)
  {
    if (observation.repairedOnJobUid || observation.condemnAssetReuseParts)
    {
      return false;
    }

    return true;
  }


  showJob(jobUid)
  {
    this.appearanceService.setRedirectPage("analytics/0");
    //this.router.navigate(['/jobs/' + jobUid]);
  }


  async showObservation(observationUid)
  {
    const modal = await this.modalController.create({
      component: ModalSingleObservationComponent,
      backdropDismiss: false,
      componentProps: { observationUid: observationUid },
      cssClass: 'ninety8-screen-modal',
      id: 'SingleObservationModal'
    });

    modal.onDidDismiss().then((response) => {

      if (response.data)
      {
        if (response.data.reportCreated)
        {
          
        }
      }
    })

    return await modal.present();
  }
}